import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

const PageLayout = ({ children, showFooterQuote = true }) => {
  return (
    <div className="min-h-screen bg-[#fbf7ee] text-[#1e2952] flex flex-col">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer showQuote={showFooterQuote} />
    </div>
  );
};

export default PageLayout;
